import DashboardLayoutMod from "@/views/Layout/DashboardLayout";
import RevisionSolicitud
  from "@/components/PartidoPolitico/Solicitudes/SolicitudesPendientes/RevisionSolicitud/RevisionSolicitud";
import RevisionSolicitudReclamacion
  from "@/components/PartidoPolitico/Solicitudes/SolicitudesPendientes/RevisionSolicitudReclamacion/RevisionSolicitudReclamacion";
import SolicitudRevisadaVer
  from "@/components/PartidoPolitico/Solicitudes/SolicitudesRevisadas/SolicitudRevisadaVer/SolicitudRevisadaVer";
import SolicitudesTable from "@/components/PartidoPolitico/Solicitudes/SolicitudesTable";
import SolicitudesPendientesLista
  from "@/components/PartidoPolitico/Solicitudes/SolicitudesPendientes/SolicitudesPendientesLista/SolicitudesPendientesLista";
import SolicitudesRevisadasLista
  from "@/components/PartidoPolitico/Solicitudes/SolicitudesRevisadas/SolicitudesRevisadasLista/SolicitudesRevisadasLista";
import AfiliacionPPForm from "@/components/PartidoPolitico/AfiliacionPPForm/AfiliacionPPForm";
import FichaPPAfiliacion from "@/components/PartidoPolitico/FichaPPAfiliacion/FichaPPAfiliacion";
import RenunciaList from "@/components/PartidoPolitico/Renuncia/RenunciaList/RenunciaList";
import RenunciaView from "@/components/PartidoPolitico/Renuncia/RenunciaView/RenunciaView";
import module from "@/enums/module";
import action from "@/enums/action";

const partidoPoliticoMenu = {
  path: '/partido-politico',
  component: DashboardLayoutMod,
  redirect: '/partido-politico/solicitud/lista',
  meta: {module: module.PARTIDO_SOLICITUDES_PENDIENTES, action: [action.CONSULTAR], requiresAuth: true},
  children: [
    {
      path: 'solicitud/revision/:id',
      name: 'revision-id',
      component: RevisionSolicitud,
      meta: {module: module.PARTIDO_SOLICITUDES_PENDIENTES, action: [action.CREAR], title: 'Revisión de solicitud'},
    },
    {
      path: 'solicitud/reclamacion/:id',
      name: 'reclamacion-id',
      component: RevisionSolicitudReclamacion,
      meta: {
        module: module.PARTIDO_SOLICITUDES_PENDIENTES,
        action: [action.CREAR],
        requiresAuth: true,
        title: 'Revisión solicitud Reclamación'
      },
    },
    {
      path: 'solicitud/revisada/:id',
      name: 'revisada-id',
      component: SolicitudRevisadaVer,
      meta: {
        module: module.PARTIDO_SOLICITUDES_REVISADAS,
        action: [action.CONSULTAR],
        requiresAuth: true,
        title: 'Solicitud Revisada'
      },
    },
    {
      path: 'solicitud/lista',
      name: 'solicitud',
      component: SolicitudesTable,
      meta: {
        module: module.PARTIDO_SOLICITUDES_PENDIENTES,
        action: [action.CONSULTAR],
        requiresAuth: true,
        title: 'Listado de solicitudes'
      },
    },
    {
      path: 'solicitud/pendientes',
      name: 'solicitud-pendientes',
      component: SolicitudesPendientesLista,
      meta: {
        module: module.PARTIDO_SOLICITUDES_PENDIENTES,
        action: [action.CREAR],
        requiresAuth: true,
        title: 'Listado de solicitudes pendientes'
      },
    },
    {
      path: 'solicitud/revisadas',
      name: 'solicitud-revisadas',
      component: SolicitudesRevisadasLista,
      meta: {
        module: module.PARTIDO_SOLICITUDES_REVISADAS,
        action: [action.CONSULTAR],
        requiresAuth: true,
        title: 'Listado de solicitudes revisadas'
      },
    },
    {
      path: 'afiliacion/solicitud',
      name: 'afiliacion-pp-solicitud',
      component: AfiliacionPPForm,
      meta: {
        module: module.PARTIDO_AFILIACION_CIUDADANO,
        action: [action.CREAR],
        requiresAuth: true,
        title: 'Afiliación manual'
      },
    },
    {
      path: 'afiliacion/ficha',
      name: 'ficha-pp',
      component: FichaPPAfiliacion,
      meta: {
        module: module.PARTIDO_FICHA_CIUDADANO,
        action: [action.CONSULTAR],
        requiresAuth: true,
        title: 'Ficha de Afiliación'
      },
    },
    {
      path: 'renuncia/lista',
      name: 'renuncia-list',
      component: RenunciaList,
      meta: {
        module: module.PARTIDO_RENUNCIAS_AFILIACION,
        action: [action.CONSULTAR],
        requiresAuth: true,
        title: 'Listado de Renuncias'
      },
    },
    {
      path: 'renuncia/:id',
      name: 'renuncia-pp-id',
      component: RenunciaView,
      meta: {
        module: module.PARTIDO_RENUNCIAS_AFILIACION,
        action: [action.CONSULTAR],
        requiresAuth: true,
        title: 'Revisión de Renuncias'
      },
    },
  ]
};

export default partidoPoliticoMenu
